import React from "react";
import cs from "classnames";
import { HexpertResultProductCaseStoriesData, HexpertResultSummaryData, } from "../../types/hexpertResultTypes";
import './ProductCaseStudy.scss';

type ProductCaseStudyProps = HexpertResultProductCaseStoriesData & {
  reverse?: boolean;
  data: HexpertResultSummaryData;
};

export const ProductCaseStudy = ({
  reverse,
  data,
  Description,
  Image,
  ImageAltText,
  ShowMore,
  Title,
}: ProductCaseStudyProps) => {
  return (
    <div
      className={cs("c-hex-case-study-container", {
        "c-hex-case-study-container-reverse": reverse,
      })}
    >
      <div className="c-hex-case-study-image-container">
        <img src={Image} alt={ImageAltText} />
      </div>
      <div className="c-hex-case-study-text-container">
        <p className="c-hex-case-study-title">{Title}</p>
        <p className="c-hex-case-study-body">{Description}</p>
        <a href={ShowMore} className="c-hex-case-study-link">
          {data?.LocalizedTranslationResources?.WeFitCaseStoriesShowMore}
        </a>
      </div>
    </div>
  );
};
